export const IProfileRepositoryType = Symbol('IProfileRepository');
